import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  TopTextArea: {
    '& p': {
      margin: 0,
    },
  },
  subData: {
    fontSize: 13,
  },
}));

const TopTextArea = (props) => {
  const classes = useStyles();
  const { children, subData } = props;
  return (
    <>
      <div className={classes.TopTextArea}>
        <p className={classes.subData}>{subData}</p>
        {children}
      </div>
    </>
  );
};

export default TopTextArea;
